export const courseDetailsKeys = {
  all: ['course'] as const,
  details: (slug: string) => [...courseDetailsKeys.all, slug] as const,
}
